import {useIntl} from 'react-intl'
import {KTSVG} from '../../../../../_dashboard/helpers'
import {useNavigate} from 'react-router-dom'

const MailOrdersListToolbar = () => {
  const navigate = useNavigate()
  const intl = useIntl()

  return (
    <div className='d-flex flex-wrap gap-2 justify-content-end'>
      <button
        type='button'
        className='btn btn-primary btn-sm'
        onClick={() => navigate('/apps/mail-orders/new')}
      >
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        {intl.formatMessage({id: 'MAIL_ORDER.ADD'})}
      </button>
    </div>
  )
}

export {MailOrdersListToolbar}
